<script >

import {defineComponent} from "vue";
import FooterApp from "@/views/FooterApp.vue";
import HeaderApp from "@/views/headerApp.vue";
import CartView from "@/views/Cartview.vue";
import http from "@/plugins/axios";
import router from "@/router";
import push from "@/components/Menu/push.vue";

var numeral = require("numeral");
export default defineComponent({
  name: 'new-checkout',
  components: {CartView, FooterApp, HeaderApp},
  data: () => ({
    newadd : false,
    showmanyPay : false,
    detilas : false,
    facktor : 3,
    checkBank:"",
    checkNo:"",
    checkNo1:"",
    checkDate:"",
    orderShow : false,
    check:"",
    name:"",
    family: "",
    mobile:"",
    dialog: true,
    stete_id :null,
    city_id :null,
    address_id : 0,
    payType: "online",
    type :0,
    addressnew : "",
    newaddress1 : "0",
    sendP : "tipax",
    sendP1 : "tipax",
    sendP2 : "",
    newstep : 1,
    credit : 0,
    address: localStorage.getItem("address"),
    baskets :  {
      data: [],
      total: [],
    },
    stete :{
      data : [],
    },
    city :{
      data : [],
    },
    allAddress:{
      data : [],
    },
    sum : 1000,
    postalcode : "",
    delivery :{
      data : [],
    },

  }),
  methods: {
    showFormat(price){
      return numeral(price).format("0,0");
    },
    setPayType(vval){
      if(vval=='check' && this.credit) {
        var r = confirm("با انتخاب این گزینه بسته به مدت زمان تسویه قیمت های تغییر خواهد کرد.مورد تایید است.");
        if (r == true) {
          this.payType=vval;
        }
      }
      if(vval=='check' && this.credit==0) {
        alert(" این گزینه برای شما فعال نیست لطفا با مدیریت یزد تکس تماس بگیرید");
      }
      if(vval=='online'){
        this.payType=vval;
      }


      // alert(vval);
    },
    setCity(city_id){
      this.city_id = city_id;
      if(city_id==303)
        this.getdelivery(city_id);
    },
    newaddress(){


      this.newadd=true;
    },
    getdelivery(city_id=0){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/delivery",
          {
            city_id : this.city_id
          },{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.delivery = response.data;
          })
          .catch((error) => {
          });
    },
    getCity(){
      http.get("/states/city/"+this.stete_id)
          .then(response => {
            this.city = response.data;

          })
          .catch((error) => {
          });
    },
    getUser(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/user",'',{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.name = response.data.data.name;
            this.family = response.data.data.family;
            this.mobile = response.data.data.phone;
            this.credit = response.data.data.credit;
          })
          .catch((error) => {
          });
    },
    gatewaySend(){
      if(this.baskets.data.priceTotalCh > 0){
        let delivery = this.sendP;
        if (delivery=='barbari'){
          delivery = this.sendP2;
        }
        const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
        http.post("/order/add",{
          price:this.baskets.data.priceTotalCh,
          address_id:this.address_id,
          delivery:delivery,
          type_peyment:this.payType,
        },{ headers: { Authorization: AuthStr } })
            .then(response => {
              // window =
              if(this.payType=='online'){
                // alert("درحال اتصال به درگاه بانک");
                // console.log(response.data);
                window.location.href ="https://bitpay.ir/payment/gateway-"+response.data.data.trace_file+"-get"
              }else{
                window.location.href =response.data.data.redirect
                // alert("سفارش شما با شماره "+response.data.data.factor_id+" ثبت شد");
                // router.push("/home")
              }
              // console.log(response.data);

              // console.log(response.data.data);
            })
            .catch((error) => {
            });
      }else{
        window.location.href = "https://www.yazdtex.com/";
      }


    },
    getAddress(){
      this.allAddress.data=[];
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/address/get-all/"+this.type,{ headers: { Authorization: AuthStr } })
          .then(response => {
            this.allAddress = response.data
          })
          .catch((error) => {
          });
    },
    settype(n=1){
      if(this.newaddress1==1){
        this.type=2;
        this.newadd=true;
      }else{
        this.type=1;
        this.getUser();
      }

      this.stete_id = null;
      this.city_id = null;
      this.getAddress();
      if(n==1){
        this.getUser();
        $(".type1").addClass("active");
        $(".type2").removeClass("active");
      }else {
        this.name="";
        this.family="";
        this.mobile="";
        $(".type1").removeClass("active");
        $(".type2").addClass("active");
      }
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("states")
          .then(response => {
            this.stete = response.data;

          })
          .catch((error) => {
          });
    },
    saveaddress(){
      if(this.name!="" && this.family!="" && this.mobile!="" && this.addressnew!=""){
        const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
        http.post("/address/add",{
          name : this.name,
          family : this.family,
          mobile : this.mobile,
          state_id : this.stete_id,
          city_id : this.city_id,
          postcode : "111111",
          address : this.addressnew,
          type : this.type,
        },{ headers: { Authorization: AuthStr } })
            .then(response => {
              if(response.data.data.city_id==this.city_id){
                alert("ادرس با موفقیت ثبت شد");
                this.getAddress();
                this.newadd=false;
              }
            })
            .catch((error) => {
            });
      }else {
        alert("پرکردن همه موارد الزامی هست")
      }

    },
    err(){
      if(this.address_id==0){
        alert("متاسفانه ادرسی آنتخاب نشده است ")
      }
      if(this.sendP==""){
        alert("نحوه ارسال را انتخاب کنید ")
      }else{
        this.gatewaySend();
      }

    },
    setadd(){
      localStorage.setItem("address",this.addressnew);
      this.address = this.addressnew;
    },
    getCart() {
      this.newstep =3;
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/get", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.baskets = response.data;
            this.dialog= false;
            // alert("ssss"+baskets.data.priceTotal);
            // alert(baskets.data.items.length);
            if(this.baskets.data.items.length>0) {
              this.newstep=1;
            }else{

              alert("سبد خرید شما خالی است ");
              router.push("/home");
            }
            console.log( this.baskets.data);
          })
          .catch((error) => {
          });
    },
    StepBasket(){
      router.push("/cart");
    },
    prevStep(){
      this.newstep=1;
    },
    nextStep(){
      if(this.newstep==2){
        this.err();
      }else{
        if(this.name!="" && this.family!="" && this.mobile!="" && this.address_id > 0 && this.sendP!=""){
          if(this.sendP!='barbari' ){
            this.newstep=2;
          }else{
            if(this.sendP=='barbari' && this.sendP2!='') {
              this.newstep=2;
            }
            else{
              alert("خطا : پرکردن همه موارد الزامی هست");
            }
          }

        }else{
          alert("خطا : پرکردن همه موارد الزامی هست");
        }
      }

    },
    updateAdd(){
      this.allAddress.data=[];
    }
  },
  updated() {
    if(this.type ){

    }
  },
  mounted() {
    this.getCart();
    this.settype(1);
    this.getdelivery();
  },
});
</script>

<template>
  <div class="text-center pa-4" style="direction: rtl">
    <v-dialog
        v-model="newadd"
        max-width="400"
        persistent
    >
      <v-card
          title="ادرس جدید"
          style="direction: rtl"

      >
        <div style="position: absolute;top: 25px;left: 20px;" @click="this.newadd=0;">
          <i class="fa-solid fa-remove"></i>
        </div>
        <hr/>
        <div style="padding: 0 10px">
          <div class="col-12 " >
            <template v-if="type==2">
              <div class="col-12" style="margin: 5px 0">
                <div class="col-4 float-right text-center" style="padding: 10px 0">
                  نام:
                </div>
                <div class="col-7 float-right" style="padding: 10px 0">
                  <input type="text" v-model="name" class="form-control"/>
                </div>
              </div>
              <div class="col-12" style="margin: 5px 0">
                <div class="col-4 float-right text-center" style="padding: 10px 0">
                  نام خانوادگی:
                </div>
                <div class="col-7 float-right" style="padding: 10px 0">
                  <input type="text" v-model="family" class="form-control"/>
                </div>
              </div>
              <div class="col-12" style="margin: 5px 0">
                <div class="col-4 float-right text-center" style="padding: 10px 0">
                  موبایل:
                </div>
                <div class="col-7 float-right" style="padding: 10px 0">
                  <input type="number" v-model="mobile"  class="form-control"/>
                </div>
              </div>
            </template>
            <div class="col-12" style="margin: 5px 0">
              <div class="col-4 float-right text-center" style="padding: 10px 0">
                استان:
              </div>
              <div class="col-7 float-right" style="padding: 10px 0">
                <select class="form-select" v-model="stete_id" @change="getCity" >
                  <option value="">انتخاب کنید</option>
                  <template v-for="(stete_list, index)  in stete.data" :key="index">
                    <option  :value="stete_list.id" v-text="stete_list.fa"></option>
                  </template>
                </select>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-12" style="margin: 5px 0">
              <div class="col-4 float-right text-center" style="padding: 10px 0">
                شهر:
              </div>
              <div class="col-7 float-right" style="padding: 10px 0">
                <select class="form-select" v-model="city_id">
                  <option value="">انتخاب کنید</option>
                  <template v-for="(stete_list, index)  in city.data" :key="index">
                    <option  :value="stete_list.id" v-text="stete_list.fa"></option>
                  </template>
                </select>
              </div>

            </div>
            <div class="clearfix"></div>
            <div class="col-12 address" style="margin: 5px 0">
              <div class="col-1 float-right">
                <i class="fa-solid fa-location-dot"></i>
              </div>
              <div class="col-10 float-left" style="margin: 5px 0;text-align: center">
                <div class="form-group">
                  <input  v-model="addressnew" type="text" class="form-control text-center" name="mobile" >
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <div class="col-12 " style="margin: 5px 0">
              <div class="btn btn-success" style="margin: 5px auto;padding:  10px;width: 100%" @click="saveaddress" v-text="'ثبت ادرس'"></div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
  <div class="text-center pa-4" style="direction: rtl">
    <v-dialog
        v-model="detilas"
        max-width="400"
        persistent
    >
      <v-card
          title="جزپیات سفارش"
          style="direction: rtl"

      >
        <div style="position: absolute;top: 25px;left: 20px;" @click="this.detilas=0;">
          <i class="fa-solid fa-remove"></i>
        </div>
        <hr/>
        <div style="padding: 0 10px;max-height: 400px;overflow-y: auto">
          <div class="col-12 " >
            <table border="0" class="table"  width="100%" style="padding: 10px">
              <tr>
                <td >
                <div class="col-4 float-right">
                  نام و نام خانوادگی
                </div>
                <div class="col-8 float-right text-left" v-text="name+' '+family">
                </div>
                <div class="clearfix"></div>
                </td>
              </tr>
            </table>
              <template v-for="(basket, index)  in baskets.data.items" :key="index">
                <table border="0" class="table"  width="100%" style="padding: 10px">
                <tr>
                  <td >
                    <div class="col-4 float-right">
                      نام محصول
                    </div>
                    <div class="col-8 float-right text-left" v-text="basket.product.cat_title+' '+basket.product.title">
                    </div>
                    <div class="clearfix"></div>
                  </td>
                </tr>
                </table>
              </template>
            <table border="0" class="table"  width="100%" style="padding: 10px">
              <tr>
                <td >
                  <div class="col-4 float-right">
                    جمع کل سفارش
                  </div>
                  <div class="col-8 float-right text-left" v-text="baskets.data.priceTotalDisShow+' ریال'">
                  </div>
                  <div class="clearfix"></div>
                </td>
              </tr>
            </table>
            <table border="0" class="table"  width="100%" style="padding: 10px">
              <tr>
                <td >
                  <div class="col-4 float-right">
                    تخفیف
                  </div>
                  <div class="col-8 float-right text-left" v-text="baskets.data.priceTotalChDF+' ریال'">
                  </div>
                  <div class="clearfix"></div>
                </td>
              </tr>
            </table>
            <table border="0" class="table"  width="100%" style="padding: 10px">
              <tr>
                <td >
                  <div class="col-4 float-right">
                    قابل پرداخت
                  </div>
                  <div class="col-8 float-right text-left" v-text="baskets.data.priceTotalShow+' ریال'">
                  </div>
                  <div class="clearfix"></div>
                </td>
              </tr>
            </table>
            <div class="clearfix"></div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
  <div class="main" v-if="newstep==1">
    <div class="col-12 text-center" style="background: #1fa29d;padding: 10px;color: #fff;">
      روش حمل کالای خود را انتخاب کنید
    </div>
    <div class="col-12 item" >
      <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
        <div class="col-4 float-right" style="padding-top: 18px;padding-right: 10px;">
          نام :
        </div>
        <div class="col-8 float-right" style="padding: 10px">
          <input type="text" v-model="name" class="form-control"/>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
        <div class="col-4 float-right" style="padding-top: 18px;padding-right: 10px;">
          نام  خانوادگی :
        </div>
        <div class="col-8 float-right" style="padding: 10px">
          <input type="text" v-model="family" class="form-control"/>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
        <div class="col-4 float-right" style="padding-top: 18px;padding-right: 10px;">
          موبایل :
        </div>
        <div class="col-8 float-right" style="padding: 10px">
          <input type="text" v-model="mobile" class="form-control"/>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
        <div class="col-4 float-right" style="padding-top: 18px;padding-right: 10px;">
          انتخاب آدرس :
        </div>
        <div class="col-8 float-right" style="padding: 10px">
          <template v-if="allAddress.data.length>0">
            <label class="col-12" v-for="(basket, index)  in allAddress.data" :key="index">

              <div class="col-1  float-right " style="padding-left: 10px">
                <input type="radio" v-model="address_id" :value="basket.id"  name="address_id" @change="setCity(basket.city_id)">
              </div>
              <div class="col-11 float-right" v-html="basket.address_title"></div>
              <div class="clearfix"></div>
            </label>
<!--            <div class="btn btn-success" style="margin: 5px auto;padding:  5px;width: 200px;margin: 5px auto" @click="newaddress" v-text="'ثبت آدرس جدید'"></div>-->
          </template>
          <template v-else>
            <div class="btn btn-success" style="margin: 5px auto;padding:  10px;width: 100%" @click="newaddress" v-text="'ثبت آدرس جدید'"></div>
          </template>

        </div>

        <div class="clearfix"></div>
      </div>
      <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
        <div class="col-10 float-right" style="padding-top: 18px;padding-right: 10px;font-size: 0.8rem">
          گیرنده غیر از خودم :
        </div>
        <div class="col-2 float-right" style="padding: 10px">
          <input type="checkbox" v-model="newaddress1" @change="settype" class="form-check" value="1">

        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12" style="padding: 5px;border-bottom: 1px solid #fff">
        <div class="col-4 float-right" style="padding-top: 18px;padding-right: 10px;">
          نحوه ارسال :
        </div>
        <div class="col-12 float-right" style="padding: 10px">
          <div class="col-12 sendP">
            <div class="col-3 float-right" v-if="city_id==303">
              <label style="display: block">
                <v-img
                    :src="require('../assets/peack1.jpg')"
                    width="100%"


                />
                <input type="radio" name="send" v-model="sendP" value="peack">
              </label>
            </div>
            <div class="col-3 float-right">
              <label style="display: block">
                <v-img
                    :src="require('../assets/tipax.png')"
                    width="100%"


                />
                <input type="radio" name="send"  v-model="sendP" value="tipax">
              </label>
            </div>

            <div class="col-3 float-right">
              <label style="display: block">
                <v-img
                    :src="require('../assets/barbari.png')"
                    width="100%"


                />
                <input type="radio" name="send" v-model="sendP" value="barbari">
              </label>
            </div>

          </div>
          <div class="clearfix"></div>
          <select v-if="sendP=='barbari'" v-model="sendP2" class="form-select" style="margin-top: 10px">
            <option value="">نوع باربری را انتخاب کنید</option>
            <option value="vatan" >باربری وطن </option>
            <option value="javangir" >باربری جهانگیر</option>
<!--            <option  v-for="(delivery, deliveryindex)  in delivery.data" :key="deliveryindex"-->
<!--            v-text="delivery" :value="deliveryindex"></option>-->
          </select>
<!--          <select v-if="sendP=='peack'" v-model="sendP2" class="form-select" style="margin-top: 10px">-->
<!--            <option value="">نوع پیک را انتخاب کنید</option>-->
<!--            <option  :value="'snap'" >اسنپ</option>-->
<!--            <option  :value="'peackstore'" >پیک فروشگاه</option>-->
<!--          </select>-->
        </div>
        <div class="clearfix"></div>
      </div>

    </div>
    <div style="position: fixed;background: #1fa29d;padding: 10px;color: #fff;bottom: 60px;text-align: center;width: 100vw" >
      <div class="col-6 float-right" @click="StepBasket" style="border-left: 1px solid #fff">
        بازگشت به سبد خرید
      </div>
      <div class="col-6 float-right" @click="nextStep">
        مرحله بعدی
      </div>
    </div>
  </div>
  <div class="main" v-if="newstep==2">
    <div class="col-12 text-center" style="background: #1fa29d;padding: 10px;color: #fff;">
      روش پرداخت خود را انتخاب کنید
    </div>
    <div class="col-12" style="margin: 20px auto;min-height: 100px;background: rgb(31, 162, 157);border-radius: 15px;max-width: 94%;padding: 15px 10px 10px 10px;position: relative">
      <h2 style="text-align: center;width: 200px;background: rgb(255, 255, 255);font-size: 1rem;padding: 3px;position: absolute;top: -14px;left: 0;right: 20%;border-radius: 0 0 5px 5px">
        اقلام سفارش
      </h2>
      <template v-for="(basket, index)  in baskets.data.items" :key="index">
        <div class="col-12 float-right" style="margin: 3px auto;background: #fff;border-left: 1px solid rgb(31, 162, 157);text-align: center;border-radius: 5px ">
          <div class="col-6 float-right" style="padding: 3px" v-text="basket.product.cat_title+' '+basket.product.title"></div>
          <div class="col-6 float-right" style="padding: 3px" v-text="'متراژ'+' : '+basket.val+' '+basket.product.uint_title"></div>
        </div>
      </template>
      <div class="clearfix"></div>
      <div class="col-12 ttt" style="padding: 10px;color: #000;border-top: 1px solid #ffffff">
        <div class="col-4 float-right">مبلغ کل سفارش :</div>
        <div class="col-8 float-right text-left" style="padding-left: 15px">{{baskets.data.priceTotalDisShow}} ریال</div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12 ttt" style="padding: 10px;color: #000;border-top: 1px solid #ffffff">
        <div class="col-4 float-right">مجموع تخفیف اپ :</div>
        <div class="col-8 float-right text-left" style="padding-left: 15px">{{baskets.data.priceTotalChDF}} ریال</div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12 ttt" style="padding: 10px;color: #000;border-top: 1px solid #ffffff">
        <div class="col-4 float-right">مبلغ قابل پرداخت :</div>
        <div class="col-8 float-right text-left" style="padding-left: 15px">{{baskets.data.priceTotalChShow}} ریال</div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="col-6" style="margin: 3px auto;background: #ffc600;text-align: center;border-radius: 5px ;padding: 10px" @click="StepBasket">
      ویرایش سفارش
    </div>

    <div class="col-12 " >

      <div class="col-12">
        <div v-if="payType=='online'" class="col-6 float-right onlinePay payType" >
          <h3>
            <i style="font-size: 2rem;color: rgb(31, 162, 157);margin-bottom: 10px" class="fa-regular fa-credit-card"></i><br/>
            پرداخت آنلاین</h3>
        </div>
        <div v-else class="col-6 float-right payType" @click="setPayType('online')">
          <h3>
            <i style="font-size: 2rem;color: rgb(31, 162, 157);margin-bottom: 10px" class="fa-regular fa-credit-card"></i><br/>
            پرداخت آنلاین</h3>
        </div>

        <div v-if="payType=='check'" class="col-6 float-right checkPay payType" >
          <h3>
            <i style="font-size: 2rem;color: rgb(31, 162, 157);margin-bottom: 10px" class="fa-solid fa-wallet"></i><br/>
            پرداخت مدت دار</h3>
        </div>
        <div v-else class="col-6 float-right payType" @click="setPayType('check')">
          <h3>
            <i style="font-size: 2rem;color: rgb(31, 162, 157);margin-bottom: 10px" class="fa-solid fa-wallet"></i><br/>
            پرداخت مدت دار</h3>
        </div>
        <template v-if="showmanyPay">
          <div v-if="payType=='many'" class="col-4 float-right manyPay payType" >
            <h3>واریز به حساب</h3>
          </div>
          <div v-else class="col-4 float-right manyType payType" @click="setPayType('many')">
            <h3>واریز به حساب</h3>
          </div>
        </template>

        <div class="clearfix"></div>
      </div>
      <div  v-if="payType=='check1'" style="border: 1px dashed;margin: 10px auto;padding: 10px" class="col-12 checKK">
        <div class="form-group col-12">
          <div class="col-4 float-right" style="font-size: 0.9rem;margin-top: 7px">
            شماره صیادی چک
          </div>
          <div class="col-8 float-right" style="font-size: 0.9rem">
            <input type="text" class="form-control" v-model="checkNo">
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group col-12">
          <div class="col-4 float-right" style="font-size: 0.9rem;margin-top: 7px">
            شماره چک
          </div>
          <div class="col-8 float-right" style="font-size: 0.9rem">
            <input type="text" class="form-control" v-model="checkNo1">
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group col-12">
          <div class="col-4 float-right" style="font-size: 0.9rem;margin-top: 7px">
            تاریخ چک
          </div>
          <div class="col-8 float-right" style="font-size: 0.9rem">
            <input type="text" class="form-control" v-model="checkDate">
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group col-12">
          <div class="col-4 float-right" style="font-size: 0.9rem;margin-top: 7px">
            نام بانک
          </div>
          <div class="col-8 float-right" style="font-size: 0.9rem">
            <input type="text" class="form-control" v-model="checkBank">
          </div>
          <div class="clearfix"></div>
        </div>

      </div>

      <div class="clearfix"></div>
    </div>
    <div class="col-12 hrr" style="background: #d7d7d7;padding: 10px">

      <div class="col-6 float-right text-center">
        <a href="https://trustseal.enamad.ir/?id=550095&Code=MioS8nnmDvccxxgvKJeahCL2NIm70u3x" target="_blank">
          <img
              :src="require('../assets/enamd.png')"
              width="30%"


          />
          <br/>
          نماد اعتماد
        </a>

      </div>
      <div class="col-6 float-right text-center">
        <img
            :src="require('../assets/pay-icon.png')"
            width="30%"


        />
        <br/>
        پرداخت امن
      </div>
      <div class="clearfix"></div>
    </div>
    <div style="position: fixed;background: #1fa29d;padding: 10px;color: #fff;bottom: 60px;text-align: center;width: 100vw" >
      <div class="col-6 float-right" @click="prevStep" style="border-left: 1px solid #fff">
        مرحله قبلی
      </div>
      <div class="col-6 float-right" @click="nextStep">
        ثبت نهایی سفارش
      </div>
      <div class="clearfix"></div>

    </div>
  </div>
</template>

<style scoped>
.checKK .form-group{
  margin: 5px auto;
}
.payType h3{
  font-size: 0.8rem;
  padding: 20px 0;
  color: #b9b9b9;
  border: 1px solid #e5e5e5;
}
.onlinePay h3{
  border: 1px solid #626262 !important;
  background: #626262;
  color:#fff;
}
.checkPay h3{
  border: 1px solid #626262 !important;
  background: #626262;
  color:#fff;
}
.manyPay h3{
  border: 1px solid #626262 !important;
  background: #626262;
  color:#fff;
}
.payType{
  text-align: center;
  padding: 3px;
}
.main{
  direction: rtl;
  padding: 28px 0 100px;
  height: fit-content;
}
.col-12.item {
  width: 94vw;
  margin: 10px;
  background: #e5e5e5;
  font-size: 0.8rem;
}
.ttt{
  font-size: 0.8rem;
}
.col-12.itemd {
  width: 94vw;
  margin: 10px;
  background: #efefef;
  font-size: 0.8rem;
}
.sendP .col-3{
  margin: 0 10px;
}
.sendP .col-3{
  text-align: center;
  border: 1px dashed;
  min-height: 133px;
  min-height: 140px;
  background: #fff;
}
tr{
  background: #e8e8e8;
  border-bottom: 1px solid #a9a9a9;
}
.hrr a{
  color: #000;
  text-decoration: none;
}
</style>